import apiClient from "../../utils/apiClient";

const API_URL = "/formfields";

export async function getFormFields(serviceId) {
  try {
    const response = await apiClient.get(`${API_URL}/${serviceId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching form fields:', error);
    throw error;
  }
}